import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { allBloquesPedagogicosAction } from '../../../control_estudios/bloques_pedagogicos/BloquesPedagogicosAction';
import { allDocentesAction } from '../../../control_estudios/docentes/DocentesAction';
import { ACTIVO_DOCENTES } from '../../../control_estudios/docentes/DocentesReducer';
import SelectFieldDocentesComponent from '../../../control_estudios/docentes/components/SelectFieldDocentes';
import SelectFieldMateriasComponent from '../../../control_estudios/materias/components/SelectFieldMaterias';
import { allPlanEvaluacionAction } from '../../../control_estudios/plan_evaluacion/plan_evaluacion/PlanEvaluacionAction';
import { allSeccionesAction } from '../../../control_estudios/secciones/SeccionesAction';
import SelectFieldSeccionesComponent from '../../../control_estudios/secciones/components/SelectFieldSecciones';
import { allEstudiantesNotasBlopedAction } from '../NotasBlopedAction';
import {
  LOADING_PLANEVA,
  PARAMS_NOTAS_BLOPED,
  PLANEVA_NOTAS_BLOPED,
} from '../NotasBlopedReducer';

const FiltrosNotasBlopedComponent = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const notasBlopedStore = Redux.useSelector((state) => state.notasBloped);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );
  const seccionesStore = Redux.useSelector((state) => state.secciones);

  const [materias, setMaterias] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      if (
        bloquesPedagogicosStore.all &&
        bloquesPedagogicosStore.all.length === 0
      ) {
        await allBloquesPedagogicosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }

      if (seccionesStore.all && seccionesStore.all.length === 0) {
        await allSeccionesAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }

      if (docentesStore.all && docentesStore.all.length === 0) {
        await allDocentesAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    async function fetchData() {
      if (
        notasBlopedStore.params.idBloquePedagogico &&
        notasBlopedStore.params.idMateria &&
        notasBlopedStore.params.idSeccion
      ) {
        await allEstudiantesNotasBlopedAction(
          dispatch,
          notasBlopedStore.params,
          true,
        );
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    notasBlopedStore.params.idBloquePedagogico,
    notasBlopedStore.params.idMateria,
    notasBlopedStore.params.idSeccion,
  ]);

  React.useEffect(() => {
    async function fetchData() {
      if (
        notasBlopedStore.params.idMateria &&
        notasBlopedStore.params.idDocente
      ) {
        dispatch({ type: PLANEVA_NOTAS_BLOPED, payload: null });
        await allPlanEvaluacionAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
          idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
          idDocente: notasBlopedStore.params.idDocente,
          idMateria: notasBlopedStore.params.idMateria,
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notasBlopedStore.params.idDocente, notasBlopedStore.params.idMateria]);

  React.useEffect(() => {
    if (notasBlopedStore.params.idBloquePedagogico) {
      dispatch({ type: LOADING_PLANEVA, payload: true });
      const planEva = planEvaluacionStore.all.find(
        (el) =>
          el.seccion.id === notasBlopedStore.params.idSeccion &&
          el.fechaBloque.bloquePedagogico.id ===
            notasBlopedStore.params.idBloquePedagogico &&
          el.materia.id === notasBlopedStore.params.idMateria,
      );
      dispatch({ type: PLANEVA_NOTAS_BLOPED, payload: planEva });
      setTimeout(() => {
        dispatch({ type: LOADING_PLANEVA, payload: false });
      }, 800);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    notasBlopedStore.params.idBloquePedagogico,
    notasBlopedStore.params.idSeccion,
  ]);

  React.useEffect(() => {
    if (notasBlopedStore.params.idDocente) {
      const docente = docentesStore.all.find(
        (docente) => docente.id === notasBlopedStore.params.idDocente,
      );
      dispatch({ type: ACTIVO_DOCENTES, payload: docente });
      dispatch({
        type: PARAMS_NOTAS_BLOPED,
        payload: {
          ...notasBlopedStore.params,
          idMateria: null,
        },
      });
      setMaterias(docente.materias);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notasBlopedStore.params.idDocente]);

  return (
    <>
      <Paper elevation={2} sx={{ my: 1, p: 2 }}>
        <Grid container spacing={1}>
          {loginStore.isAdmin || loginStore.isRoot ? (
            <Grid item md={3}>
              <SelectFieldDocentesComponent
                value={notasBlopedStore.params.idDocente}
                onChange={(idDocente) =>
                  dispatch({
                    type: PARAMS_NOTAS_BLOPED,
                    payload: {
                      ...notasBlopedStore.params,
                      idDocente,
                    },
                  })
                }
                data={
                  loginStore.isTeacher
                    ? docentesStore.activo.materias
                    : materias
                }
              />
            </Grid>
          ) : null}
          <Grid item md={loginStore.isTeacher ? 3 : 2}>
            <SelectFieldMateriasComponent
              value={notasBlopedStore.params.idMateria}
              onChange={(idMateria) =>
                dispatch({
                  type: PARAMS_NOTAS_BLOPED,
                  payload: {
                    ...notasBlopedStore.params,
                    idMateria,
                  },
                })
              }
              data={
                loginStore.isTeacher ? docentesStore.activo.materias : materias
              }
            />
          </Grid>
          <Grid item md={loginStore.isTeacher ? 3 : 3}>
            <FormControl fullWidth size="small">
              <InputLabel id={`label_${CONST.bloquePedagogico.name}`}>
                {CONST.bloquePedagogico.label}
              </InputLabel>
              <Select
                id={CONST.bloquePedagogico.name}
                value={notasBlopedStore.params.idBloquePedagogico}
                labelId={`label_${CONST.bloquePedagogico.name}`}
                label={CONST.bloquePedagogico.label}
                onChange={(e) =>
                  dispatch({
                    type: PARAMS_NOTAS_BLOPED,
                    payload: {
                      ...notasBlopedStore.params,
                      idBloquePedagogico: Number(e.target.value),
                    },
                  })
                }
              >
                {bloquesPedagogicosStore.all.map((el, index) => {
                  return (
                    <MenuItem key={`bloquePedagogico-${index}`} value={el.id}>
                      {el.nombre}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={loginStore.isTeacher ? 5 : 4}>
            <SelectFieldSeccionesComponent
              isAutoComplete
              value={notasBlopedStore.params.idSeccion}
              onChange={(idSeccion) =>
                dispatch({
                  type: PARAMS_NOTAS_BLOPED,
                  payload: {
                    ...notasBlopedStore.params,
                    idSeccion,
                  },
                })
              }
              data={
                loginStore.isTeacher ? docentesStore.activo.secciones : null
              }
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default FiltrosNotasBlopedComponent;
